import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const contestDetails = (contestId) => {
  return instance.post(`${base_apis.contest}/get/${contestId}`).then((res) => {
    return res;
  });
};
export const contestJoinedUserDetails = (contestId, data) => {
  return instance.post(`${base_apis.contest}/userDetails/${contestId}`, data).then((res) => {
    return res;
  });
};
export const contestPlayers = (contestId, data) => {
  return instance.post(`${base_apis.contest}/joinedUser/${contestId}`, data).then((res) => {
    return res;
  });
};
export const contestRules = (contestId) => {
  return instance.post(`${base_apis.contest}/rules/${contestId}`).then((res) => {
    return res;
  });
};

export const getContestList = (data) => {
  return instance.post(`${base_apis.contestList}`, data)
    .then((res) => {
      return res;
    });
};
export const contestJoin = (data) => {
  return instance.post(`${base_apis.contestJoin}`, data)
    .then((res) => {
      return res;
    });
};
export const getPrizePool = (data) => {
  return instance.post(`${base_apis.contestPrizePool}/${data}`)
    .then((res) => {
      return res;
    });
};

export const contestByCode = (data) => {
  return instance.post(`${base_apis.contest}/byCode`, data)
    .then((res) => {
      return res;
    });
};

export const myContestList = (data) => {
  return instance.post(`${base_apis.joinUserContest}/list`, data)
    .then((res) => {
      return res;
    });
};